var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecordingActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.97656 11.9766C9.24609 11.9766 11.9531 9.26367 11.9531 6C11.9531 2.73047 9.24023 0.0234375 5.9707 0.0234375C2.70703 0.0234375 0 2.73047 0 6C0 9.26367 2.71289 11.9766 5.97656 11.9766ZM5.98242 8.36133C4.66992 8.36133 3.60938 7.30078 3.60938 5.98828C3.60938 4.68164 4.66992 3.62695 5.98242 3.62695C7.28906 3.62695 8.34961 4.68164 8.34961 5.98828C8.34961 7.30078 7.28906 8.36133 5.98242 8.36133Z",
    fill: "#F24822"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordingActive);
export default __webpack_public_path__ + "static/media/recording-active.e82847b81f576f841d4b323c0c74a877.svg";
export { ForwardRef as ReactComponent };